(() => {
  "use strict";
  const button = document.querySelector("[data-whatsapp-button]");
  if (!button) return;

  // The sticky mobile cart bar (assets/cart-bar.css) is a full-width bar
  // fixed to the bottom of the viewport at a higher z-index, so this button
  // needs to shift up while it's visible instead of being covered by it.
  const cartBar = document.querySelector(".cart-bar");
  if (!cartBar) return;

  const sync = () => {
    button.classList.toggle("is-raised", cartBar.classList.contains("is-visible"));
  };

  sync();
  new MutationObserver(sync).observe(cartBar, { attributes: true, attributeFilter: ["class"] });
})();
